function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.31 10.224l3.69-.005m0 0l-.004-3.69M13 10.22L7.782 5.013a.461.461 0 00-.646.001L5.016 7.14a.461.461 0 01-.645 0L1 3.776",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgDecrease = function SvgDecrease(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgDecrease;